<template>
  <div>
    <v-dialog v-model="dialog" width="600" persistent transition="dialog-bottom-transition" @keydown.esc="close">
        <v-card class="scouting-add-edit-dialog-card">
            <v-toolbar dark color="primary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Location</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
            </v-toolbar>
            <v-form ref="form">
                <v-layout wrap ma-2>
                    <v-flex xs12 pb-2>
                        <span>Please record the location for the spot</span>
                    </v-flex>
                    <v-flex xs12 mb-2>
                        <div style="display: inline-flex; align-items: center; gap: 8px;">
                            <v-btn fab small color="info" @click="getLocation" v-if="geoEnalbed">
                                <v-icon large>location_on</v-icon>
                            </v-btn>
                            <v-btn fab small color="primary" @click="openMapPicker">
                                <v-icon large>map</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs12 mb-2>
                        <v-text-field box clearable v-model='latitude' type="number" label="Latitude"></v-text-field>
                    </v-flex>
                    <v-flex xs12 mb-2>
                        <v-text-field box clearable v-model='longitude' type="number" label="Longitude"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-alert type="error" :value="error != null" outline>{{ error }}</v-alert>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="dialog-action-buttons">
                    <v-flex xs12 sm6>
                        <v-btn block color="error" @click="close">Cancel</v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 >
                        <v-btn block color="success" @click="saveGPS">Set Location</v-btn>
                    </v-flex>
                </v-layout>   
            </v-form>
        </v-card>
    </v-dialog>

    <!-- Map Picker Dialog -->
    
        <!-- Map Picker Dialog as component -->
        <MapPickerDialog
            ref="mapPickerDialog"
            @pick="onMapPick"
        />
    </div>
</template>

<script>

import MapPickerDialog from '../maps/MapPickerDialog.vue';

export default {
    data() {
        return {
            latitude: null,
            longitude: null,
            error: null,
            mapDialog: false,
            // locationID: null
        }
    },
    props: [
        "dialog",
        "gps",
        "locationID",
    ],
    components: {
        MapPickerDialog
    },
    computed: {
        geoEnalbed() {
            return "geolocation" in navigator
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
        getLocation() {
            this.error = null;
            let _this = this;
            navigator.geolocation.getCurrentPosition(pos => {
                _this.latitude = pos.coords.latitude;
                _this.longitude = pos.coords.longitude;
            }, err => {    
                this.error = err.message;            
                console.log("Error Getting Location", err);
            });
        },
        saveGPS() {
            this.$emit('save', { Latitude: this.latitude, Longitude: this.longitude });
        },
        onMapPick({ latitude, longitude }) {
            this.latitude = latitude;
            this.longitude = longitude;
        },
        openMapPicker() {
            this.$refs.mapPickerDialog.showDialog({
                latitude: this.latitude,
                longitude: this.longitude,
                locationID: this.locationID
            });
        }
    },
    created() {
        if (this.gps) {
            this.latitude = this.gps.latitude;
            this.longitude = this.gps.longitude;
        }
        // Example: set locationID from route or props if available
        if (this.$route && this.$route.params && this.$route.params.LocationID) {
            this.locationID = this.$route.params.LocationID;
        }
    }
  }
</script>

<style>

@import 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';
</style>
